// The robot's two heading frames (navigation mapper.h, Mapper::to_azimuth /
// from_azimuth).
//
// Waypoint.bearing — position.z on the wire, Waypoint.bearing_azimuth_deg
// here — is a lon/lat-frame AZIMUTH: the direction measured in degree space,
// where a step east is a step in longitude and a step north a step in
// latitude. The robot drives in metres, and a degree of longitude is only
// cos(lat) of a degree of latitude long, so the same direction has a
// different angle in the metre frame. The robot converts with an ellipse
// whose axes are the metres-per-degree of latitude and longitude at the
// current position; this mirrors that exactly (up to the robot's truncated
// DEG2RAD/RAD2DEG constants, a 0.02 % effect the preview does not care
// about).
//
// Only the azimuth → metres direction is needed: pathfinder emits azimuths, and
// the consumers (zone extras placement, /path/simulate's inputs) work in metres.

// mapper.h store_mpd_lat / store_mpd_lon (WGS-84 series).
export function metresPerDegreeLat(latDeg: number): number {
  const r = (latDeg * Math.PI) / 180;

  return 111132.954 - 559.822 * Math.cos(2 * r) + 1.175 * Math.cos(4 * r);
}

export function metresPerDegreeLon(latDeg: number): number {
  return 111132.954 * Math.cos((latDeg * Math.PI) / 180);
}

// Mapper::from_azimuth: a unit step along the azimuth in degree space,
// scaled to metres per axis, re-measured as an angle. Result in [0, 2π),
// CCW+ from east — the frame missioncontrol's metre-space maths uses.
export function azimuthDegToMetricRad(azimuthDeg: number, latDeg: number): number {
  const a = (azimuthDeg * Math.PI) / 180;
  const x = metresPerDegreeLon(latDeg) * Math.cos(a);
  const y = metresPerDegreeLat(latDeg) * Math.sin(a);
  const theta = Math.atan2(y, x);

  return theta < 0 ? theta + 2 * Math.PI : theta;
}
